import { DialogComponent } from '@theme/dialog';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class DialogNotifyMe extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    // Find an internal <dialog> if present, otherwise treat this element as the dialog container
    this._dialog = this.querySelector('dialog') || this;
    this._onOpen = this._onOpen.bind(this);
    document.addEventListener('notify-me:open', this._onOpen);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener('notify-me:open', this._onOpen);
  }


  _onOpen(event) {
    const detail = event?.detail || {};

    const span = event.target.querySelector('.add-to-cart-text__content span');
    const raw = span?.textContent ?? '';
    const text = raw.replace(/\s+/g, ' ').trim().toLowerCase();

    if (text === 'unavailable') {
      return;
    }
    // Open the dialog using the existing open() method
    this.open();

    // Focus first focusable element inside the dialog
    const focusable = this.querySelector('input, button, [tabindex]:not([tabindex="-1"])');
    if (focusable) focusable.focus();
  }

  _ensureHiddenInput(form, name, value) {
    let input = form.querySelector(`input[name="${name}"]`);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    input.value = value;
  }

  _setInputValue(selector, value) {
    const input = this.querySelector(selector);
    if (input) input.value = value;
  }

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('dialog-notify-me')) {
  customElements.define('dialog-notify-me', DialogNotifyMe);
}

class notifymeForm extends HTMLElement {
  constructor() {
    super();
    this.formEl = this.querySelector('form');
    this.name = this.querySelector('input[name="contact[name]"]').value;
    this.email = this.querySelector('input[name="contact[email]"]').value;
    this.phone = this.querySelector('input[name="contact[country]"]').value;
    this.button = this.querySelector('button[type="submit"]');
    this.sendUrl = this.formEl.getAttribute('action');
    this.successMessageEl = this.querySelector('.success-message');
    this.alredyErrorMessageEl = this.querySelector('.already-error-message');
    this.ErrorMessageEl = this.querySelector('.error-message');

    this.formEl.addEventListener('submit', this.onClickHandler.bind(this));
  }

  onClickHandler(event) {
    event.preventDefault();
    this.button.setAttribute('disabled', true);
    this.button.classList.add('loading');

    const data = new FormData(event.target);
    const value = Object.fromEntries(data.entries());

    this.postData(value)
  }

  async postData(data) {
    console.log(JSON.stringify(data));
    const response = await fetch(this.sendUrl, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      referrerPolicy: 'no-referrer',
      body: JSON.stringify(data)
    });
    let outcome = await response.json();
    this.handleResponse(outcome);
  }

  handleResponse(response) {
    if (response.success === 'Data processed successfully') {
      this.button.classList.remove('loading')
      this.button.removeAttribute('disabled');
      this.formEl.classList.add('hidden');
      this.successMessageEl.classList.remove('hidden');
    } else if (response.error === '"User already registered for this product"') {
      this.button.classList.remove('loading')
      this.button.removeAttribute('disabled');
      this.formEl.classList.add('hidden');
      this.alredyErrorMessageEl.classList.remove('hidden');
    } else {
      this.button.classList.remove('loading')
      this.button.removeAttribute('disabled');
      this.formEl.classList.add('hidden');
      this.ErrorMessageEl.classList.remove('hidden');
    }
  }
}

customElements.define('notifyme-form', notifymeForm);